import { Injectable } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { AuthService } from './auth.service';
import { TableIdType } from 'src/app/constants/table.constant';
import { ISortState } from 'src/app/models/users/userProfile';

@Injectable({
  providedIn: 'root',
})
export class TableSortService {
  constructor(private authService: AuthService) {}

  getSortState(tableId: TableIdType): ISortState | null {
    const preference = this.authService.preference$.getValue();
    const sortState = preference?.tableSorts?.[tableId];
    return sortState ?? null;
  }

  setSortState(tableId: TableIdType, sort: Sort): void {
    const preference = this.authService.preference$.getValue();
    const tableSorts = { ...preference.tableSorts, [tableId]: { column: sort.active, direction: sort.direction } };
    const updatedPreference = { ...preference, tableSorts };
    this.authService.setDateFormat(updatedPreference);
    const name = this.authService.authInformation?.name;
    this.authService.updatePreference({ name, preference: updatedPreference }).subscribe();
  }

  applySortToMatSort(matSort: MatSort, tableId: TableIdType): void {
    const sortState = this.getSortState(tableId);
    if (!sortState || !sortState.column || !sortState.direction) return;
    matSort.active = sortState.column;
    matSort.direction = sortState.direction;
    matSort.sortChange.emit({ active: sortState.column, direction: sortState.direction });
  }
}
